var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAreaChartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5130_31185)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5130_31185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4275 0.713379L8.37701 3.95432C8.06233 4.20853 7.66366 4.33698 7.25882 4.31462C6.85398 4.29226 6.47213 4.12068 6.1877 3.83338L5.1537 2.81757C4.86877 2.5366 4.49086 2.36818 4.0903 2.34371C3.68974 2.31924 3.29395 2.44037 2.97656 2.68455L-0.441406 5.33292",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.441406 8.92651L3.43878 5.91534C3.63074 5.76844 3.8698 5.69603 4.11153 5.71161C4.35326 5.72718 4.58108 5.8297 4.75236 6L4.87397 6.12092C5.51376 6.77697 6.37906 7.16882 7.29683 7.21814C8.21461 7.26746 9.11733 6.97063 9.82453 6.38697L12.4275 4.29488V13.0122H-0.441406V8.92651Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5130_31185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5130_31185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 13,
    transform: "translate(-1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaChartIcon);
export default __webpack_public_path__ + "static/media/area-chart-icon.879399c57c40bb7e917cf4b7e4756d92.svg";
export { ForwardRef as ReactComponent };